import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=11f6e792&scoped=true&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style1 from "@/assets/usercenter.less?vue&type=style&index=1&id=11f6e792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6e792",
  null
  
)

export default component.exports